import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ETAPA_ENTREGA_CHAVES } from "../../../../Constants/EntregaChaves";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { ListarAcaoEtapaController } from "../../../../Controllers/Geral/AcaoEtapa/AcaoEtapaControllers";
import { ExecutarAcaoAtendimentoController } from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { IAtendimentoExtraDetalhado } from "../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { IAcaoEtapa } from "../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";
import BotaoResponderPesquisaDeSatisfacao from "../../../../Pages/AssistenciaTecnica/Atendimento/AcoesAssistenciaTecnica/BotoesAssistenciaTecnica/BotaoResponderPesquisaDeSatisfacao";
import { ACESSOS } from "../../../../Routes/Acessos";
import { Spinner } from "../../../Loding/SpinnerPadrao";
import ModalComponent from "../../../Modais";
import { IComponentModal } from "../../../Modais/IModalComponent";
import {
    faClipboard,
    faFastForward,
    faFlagCheckered,
    faInfoCircle,
    faQuestion,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BotaoClienteNaoCompareceu from "../../../../Pages/VistoriaEntregaDeChaves/AcoesVistoria/BotaoClienteNaoCompareceu";
import BotaoVistoriaNaoRealizada from "../../../../Pages/VistoriaEntregaDeChaves/AcoesVistoria/BotaoVistoriaNaoRealizada";
import JustificativaCancelamentoCancelarCaso from "../../../../Pages/AtendimentoCliente/Atendimento/Formularios/JustificativaCancelamentoCancelarCaso";
import JustificativaCancelamentoFinalizarCaso from "../../../../Pages/AtendimentoCliente/Atendimento/Formularios/JustificativaCancelamentoFinalizarCaso";
import BotaoAssinarTermo from "../../../../Pages/AssistenciaTecnica/Atendimento/AcoesAssistenciaTecnica/BotoesAssistenciaTecnica/BotaoAssinarTermo";
import { IAtendimentoRepasseCaso } from "../../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import { useUserInfor } from "../../../../Context/User";
import SpinnerComponent from "../../../Loding/Spinner";
import { EnviarPesquisaSatisfacaoWppController } from "../../../../Controllers/HelpDesk/GestaoAtendimentos/GestaoAtendimentosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { ReenviarEmailPesquisaSatisfacaoController } from "../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";

interface IAcoesProps {
    ID_ETAPA: number;
    ID_CASO: number;
    bloquearAcoes?: boolean;

    gestaoRepasseDados?: IAtendimentoRepasseCaso | undefined;
    gestaoRepasseDadosLoading?: boolean;
    salvando?: boolean;
    handleRepasseFinanceiro?: any;
}

const TIPO_CASO_LINK = {
    Atendimento: {
        Link: ACESSOS.ATENDIMENTO.TELAS.GESTAO_ATENDIMENTOS.MEUS_ATENDIMENTOS
            .DS_PATH,
    },
    Cobranca: {
        Link: ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.DS_PATH,
    },
    Assistencia: {
        Link: ACESSOS.ASSISTENCIA.TELAS.GESTAO_ATENDIMENTOS.TODOS.DS_PATH,
    },
    EntregaChaves: {
        Link: ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTOS.TODOS.DS_PATH,
    },
};

export default function Acoes(props: IAcoesProps) {
    const history = useHistory();

    const emccampMode = "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const [lstAcoes, setLstAcoes] = useState<Array<IAcaoEtapa>>();
    const [loadingAcoes, setLoadingAcoes] = useState(false);
    const [executando, setExecutando] = useState(0);

    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const { TIPO_CASO, updateAtendimento, Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();
    const { Config } = useUserInfor();

    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;

    const AtendimentoDetalhado = useAtendimentoPage()
        .Atendimento as IAtendimentoExtraDetalhado;

    const {
        execute: EnviarPesquisaSatisfacaoWpp,
        loading: EnviarPesquisaSatisfacaoWppLoading,
    } = useAsyncCallback(EnviarPesquisaSatisfacaoWppController);

    const {
        execute: ReenviarEmailPesquisaSatisfacao,
        loading: ReenviarEmailPesquisaSatisfacaoLoading,
    } = useAsyncCallback(ReenviarEmailPesquisaSatisfacaoController);

    const isLoadingEnvioPesquisaSatisfacao =
        EnviarPesquisaSatisfacaoWppLoading ||
        ReenviarEmailPesquisaSatisfacaoLoading;

    const execute = async (
        ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
    ) => {
        setExecutando(ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO);
        return ExecutarAcaoAtendimentoController(
            props.ID_CASO,
            ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
        )
            .then((res) => {
                if (!res) {
                    history.push(TIPO_CASO_LINK[TIPO_CASO]?.Link);
                } else {
                    updateAtendimento();
                    ReloadHistorico();
                }
            })
            .finally(() => setExecutando(0));
    };

    function mostrarPreencherFormularioVistoria() {
        return [
            ETAPA_ENTREGA_CHAVES.RESPONDER_PESQUISA_ENTREGA_CHAVES.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.REALIZAR_VISTORIA_PREVIA.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.REALIZAR_VISTORIA.CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.REALIZAR_VISTORIA_PREVIA_UNIDADE.CD_ETAPA,
        ].some((etapa) => etapa === AtendimentoDetalhado?.CD_ETAPA);
    }

    function mostrarPreencherFormularioAssinarTermoVistoria() {
        return [
            ETAPA_ENTREGA_CHAVES.ENTREGA_REALIZADA_ASSINAR_TERMO.CD_ETAPA,
        ].some((etapa) => etapa === AtendimentoDetalhado?.CD_ETAPA);
    }

    function mostrarReagendarVistoria() {
        return [ETAPA_ENTREGA_CHAVES.REALIZAR_VISTORIA.CD_ETAPA].some(
            (etapa) =>
                etapa === AtendimentoDetalhado?.CD_ETAPA &&
                Config.ConfigVistoriaDTO
                    .FL_UTILIZAR_ACAO_DINAMICA_PADRAO_VISTORIA
        );
    }

    useEffect(() => {
        setLoadingAcoes(true);
        setLstAcoes([]);
        ListarAcaoEtapaController(props.ID_ETAPA, props.ID_CASO).then((res) => {
            const acoesFiltradas =
                res.ACOES_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO.filter(
                    (r) =>
                        !Atendimento?.DT_FIM ||
                        r.DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO !==
                            "FINALIZAR CASO"
                );
            setLstAcoes(acoesFiltradas);
            setLoadingAcoes(false);
        });
    }, [
        props.ID_ETAPA,
        Atendimento?.DT_FIM,
        props.ID_CASO,
        AtendimentoDetalhado.CD_ETAPA,
    ]);

    return (
        <div className="d-flex row card card-custom col-12 justify-content-around p-4 mt-5 m-0">
            <h4 className="text-center mb-0">Ações de Etapa</h4>
            <hr />
            {loadingAcoes ? (
                <SpinnerComponent />
            ) : (
                <>
                    {AtendimentoDetalhado?.FL_CASO_PARALIZADO ? (
                        <span className="text-center text-danger">
                            O caso encontra-se paralisado, portanto as ações de
                            etapa estão indisponíveis.
                        </span>
                    ) : (
                        <>
                            {!!props.bloquearAcoes && (
                                <span className="w-100 d-flex justify-content-center align-items-center g-2">
                                    Ações bloqueadas porque os status
                                    obrigatórios não foram preenchidos{" "}
                                    <FontAwesomeIcon
                                        size="1x"
                                        className="svg-icon svg-icon-md mr-1 d-lg-flex"
                                        icon={faInfoCircle}
                                    />
                                </span>
                            )}
                            <div className="g-5  d-flex flex-row flex-wrap justify-content-center">
                                {!(emccampMode === ID_ORGANIZACAO) && (
                                    <>
                                        {mostrarPreencherFormularioVistoria() && (
                                            <BotaoResponderPesquisaDeSatisfacao
                                                setShow={setShow}
                                                setModal={setModal}
                                                className="btn btn-primary d-flex align-items-center justify-content-center g-2 m-2"
                                                tpPesquisa="Vistoria"
                                                titulo="Preencher Formulário"
                                            />
                                        )}

                                        {mostrarPreencherFormularioAssinarTermoVistoria() && (
                                            <BotaoAssinarTermo
                                                setShow={setShow}
                                                setModal={setModal}
                                                className="btn btn-primary d-flex align-items-center justify-content-center g-2 m-2"
                                                tpPesquisa="Vistoria"
                                                titulo="Assinar Termo"
                                            />
                                        )}
                                        {mostrarReagendarVistoria() && (
                                            <>
                                                <BotaoClienteNaoCompareceu
                                                    setShow={setShow}
                                                    setModal={setModal}
                                                />

                                                <BotaoVistoriaNaoRealizada
                                                    setShow={setShow}
                                                    setModal={setModal}
                                                />
                                            </>
                                        )}
                                    </>
                                )}

                                {lstAcoes?.map((acao) => (
                                    <button
                                        className={`btn btn-${
                                            acao.DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ===
                                                "CANCELAR CASO" ||
                                            acao.DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ===
                                                "FINALIZAR CASO"
                                                ? "danger"
                                                : "primary"
                                        } d-flex align-items-center justify-content-center g-2 m-2`}
                                        key={
                                            acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        }
                                        disabled={
                                            executando > 0 ||
                                            (acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO !==
                                                38 &&
                                                acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO !==
                                                    39 &&
                                                acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO !==
                                                    43 &&
                                                acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO !==
                                                    44 &&
                                                props.bloquearAcoes) ||
                                            AtendimentoDetalhado?.FL_CASO_PARALIZADO
                                        }
                                        onClick={() => {
                                            // Confere se o Modulo não é repasse (5)
                                            if (
                                                AtendimentoDetalhado.ID_TIPO_CASO !==
                                                5
                                            ) {
                                                if (
                                                    acao.DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ===
                                                    "CANCELAR CASO"
                                                ) {
                                                    // Se a ação for de cancelar ele ira mostrar um dropdwon com os motivos cancelamentos e um textarea de justificativa
                                                    setShow(true);
                                                    setModal({
                                                        headerComponent:
                                                            "Justificativa para cancelamento",
                                                        IconHeader: faQuestion,
                                                        size: "lg",
                                                        Component: () => (
                                                            <JustificativaCancelamentoCancelarCaso
                                                                setShow={
                                                                    setShow
                                                                }
                                                                execute={
                                                                    execute
                                                                }
                                                                ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO={
                                                                    acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                                }
                                                            />
                                                        ),
                                                    });
                                                } else if (
                                                    acao.DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ===
                                                        "FINALIZAR CASO" &&
                                                    acao.FL_INSERIR_JUSTIFICATIVA_FECHAMENTO_CASO ===
                                                        true
                                                ) {
                                                    // Se a ação for de finalizar atendimento e possuir a flag de justificativa obrigatoria, mostrar o text area para inserir a justificativa
                                                    setShow(true);
                                                    setModal({
                                                        headerComponent:
                                                            "Justificativa de fechamento",
                                                        IconHeader: faQuestion,
                                                        size: "lg",
                                                        Component: () => (
                                                            <JustificativaCancelamentoFinalizarCaso
                                                                setShow={
                                                                    setShow
                                                                }
                                                            />
                                                        ),
                                                    });
                                                } else {
                                                    execute(
                                                        acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                    );
                                                }
                                                // Confere se o Modulo é repasse (5)
                                            } else if (
                                                AtendimentoDetalhado.ID_TIPO_CASO ===
                                                5
                                            ) {
                                                if (
                                                    Config.ConfigAtendimentoDTO
                                                        .FL_AVANCAR_ETAPA_REPASSE
                                                ) {
                                                    props
                                                        .handleRepasseFinanceiro(
                                                            JSON.parse(
                                                                localStorage.getItem(
                                                                    "repasseDados"
                                                                ) ?? ""
                                                            )
                                                        ) // se a flag estiver ativa salva os dados automaticamente ao avançar
                                                        .then(() => {
                                                            execute(
                                                                acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                            );
                                                        });
                                                } else {
                                                    execute(
                                                        acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                    );
                                                }
                                            } else {
                                                execute(
                                                    acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                                );
                                            }
                                        }}
                                    >
                                        {acao.DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ===
                                            "CANCELAR CASO" ||
                                        acao.DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ===
                                            "FINALIZAR CASO" ? (
                                            <FontAwesomeIcon
                                                icon={faFlagCheckered}
                                            />
                                        ) : null}
                                        {acao.DS_TIPO_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ===
                                        "IR PARA ETAPA" ? (
                                            <FontAwesomeIcon
                                                icon={faFastForward}
                                            />
                                        ) : null}
                                        {
                                            acao.DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                        }
                                        {executando ===
                                            acao.ID_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO && (
                                            <Spinner size="sm" />
                                        )}
                                    </button>
                                ))}
                                {ACESSOS.ATENDIMENTO.ID_MODULO ===
                                    Atendimento?.ID_TIPO_CASO &&
                                    Config?.ConfigAtendimentoDTO
                                        ?.FL_ENVIO_PESQUISA_MANUAL_ATENDIMENTO && (
                                        <button
                                            className="btn btn-success d-flex align-items-center justify-content-center g-2 m-2"
                                            onClick={() => {
                                                ReenviarEmailPesquisaSatisfacao(
                                                    AtendimentoDetalhado.ID_CASO,
                                                    AtendimentoDetalhado.ID_TIPO_CASO
                                                ).then(() => {
                                                    if (
                                                        Config
                                                            ?.ConfigAtendimentoDTO
                                                            ?.FL_PESQUISA_SATISFACAO_WPP_ATENDIMENTO_CLIENTE
                                                    ) {
                                                        EnviarPesquisaSatisfacaoWpp(
                                                            AtendimentoDetalhado.ID_CASO
                                                        );
                                                    }
                                                });
                                            }}
                                            disabled={
                                                isLoadingEnvioPesquisaSatisfacao
                                            }
                                        >
                                            {isLoadingEnvioPesquisaSatisfacao ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                <FontAwesomeIcon
                                                    icon={faClipboard}
                                                />
                                            )}{" "}
                                            Enviar Pesquisa Satisfação
                                        </button>
                                    )}
                            </div>
                        </>
                    )}
                </>
            )}

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
